module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":"Login","register":"Sign up","mail":"E-Mail address"},"de":{"login":"Anmelden","register":"Registrieren","mail":"E-Mail Adresse"}}')
  delete Component.options._Ctor
}
